import { CreateModuleRequestDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { getDatoLocale } from 'modules/onboarding/lib/datoLocale'

interface CreateModuleRequestParams {
  moduleName: string
  moduleSlug: string
  recipientEmployeeIds: string[]
  message?: string
  userLocale: string
}

export const useCreateModuleRequest = () => {
  const [createModuleRequest, { loading, error }] = useMutation(CreateModuleRequestDocument, {
    extractorFn: (data) => data.modulesMutations.createModulesModuleRequest,
  })

  const create = (params: CreateModuleRequestParams) => {
    const datoFormatLocale = getDatoLocale(params.userLocale)

    return createModuleRequest({
      variables: {
        moduleName: params.moduleName,
        moduleSlug: params.moduleSlug,
        recipientEmployeeIds: params.recipientEmployeeIds,
        message: params.message,
        locale: datoFormatLocale,
      },
    })
  }

  return {
    create,
    loading,
    error,
  }
}
